"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import dispatcher from "./../dispatcher";
import Toast from "vwa/components/Toast";

import {getUserId} from "./../utils/user";

async function removeEventDescriptor(eventDescriptorId){
	try {
		const response = await api.delete("eventDescriptors", {
			eventDescriptors: [eventDescriptorId]
		});
		dispatcher.dispatch("removeEventDescriptor", eventDescriptorId);
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
}

export default async function removeNotificationConfig(eventDescriptorId) {
	await removeEventDescriptor(eventDescriptorId);
	
	try {
		const userId = getUserId();
		if(!userId){
			return;
		}
		
		const response = await api.delete("users/notifications", {
			_id: getUserId(),
			descriptors: [eventDescriptorId]
		});
		dispatcher.dispatch("removeNotificationConfig");
		return true;	
	} catch (error) {
		if ("id" in error)
			new Toast(lang.SOMETHING_WRONG, "orange");
		else throw error;
	}
	return false;
}


// WEBPACK FOOTER //
// ./src/api/removeNotificationConfig.js